// START_MODULE domain_repositories_mainrepository_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import { announcements, imageSources, news } from './content';

import { INews } from 'domain/entities/INews';
import { IAnnouncement } from 'domain/entities/IAnnouncement';

class MainRepository {
  public getAllAnnouncements = (): Promise<IAnnouncement[]> => Promise.resolve([...announcements]);

  public getAllNews = ({ start = 0, finish = news.length }: {start?: number, finish?: number}) => Promise.resolve({
    news: news.slice(start, finish),
    count: news.length,
  });

  public getNews = (id: string): Promise<INews> => {
    const item = news.find((candidate) => candidate.id === id);
    return item ? Promise.resolve(item) : Promise.reject(new Error(`Unknown news item: ${id}`));
  };

  public getImageFile = (id: string): Promise<Blob> => {
    const source = imageSources[id];
    if (!source) return Promise.reject(new Error(`Unknown image: ${id}`));
    return fetch(source).then((response) => {
      if (!response.ok) throw new Error(`Unable to load image: ${id}`);
      return response.blob();
    });
  };
}

export const mainRepository = new MainRepository();

// END_MODULE domain_repositories_mainrepository_ts
